import BlogSecTravelUpdate from "../Blog/BlogSecTravelUpdate/BlogSecTravelUpdate";
import DownloadNH from "../Common/DownloadNH";
import MainLayout from "../MainLayout";
import AuthorProfileSec1 from "./AuthorProfileSec1/AuthorProfileSec1";

export default function AuthorProfile({
  authorSlug = "",
  authorProfile = null,
  initialArticleList = [],
  initialArticleMeta = null,
  country = "UAE",
}) {
  return (
    <div>
      <MainLayout hideHeader>
        <AuthorProfileSec1
          authorSlug={authorSlug}
          authorName={authorProfile?.name}
          authorImage={authorProfile?.image}
          authorBio={authorProfile?.bio}
          articles={initialArticleList}
          initialArticleMeta={initialArticleMeta}
          country={country}
        />
        <BlogSecTravelUpdate />
        <DownloadNH />
      </MainLayout>
    </div>
  );
}
